import React from 'react'
import { Link } from 'react-router-dom'
import { UserAuth } from '../auth/Auth';
import './ReportsIndex.css';

function ReportsIndex() {
  const { MatchPermission } = UserAuth();

  const ReportCard = ({ title, icon, links }) => (
    <div className="reports-card">
      <div className="reports-card__header">
        <span className="reports-card__icon-wrap">
          <i className={`fas ${icon} reports-card__icon`} />
        </span>
        <h3 className="reports-card__title">{title}</h3>
      </div>
      <ul className="reports-card__list">
        {links.map(({ to, label }) => (
          <li key={to}>
            <Link to={to} className="reports-card__link">
              <i className="fas fa-chevron-right reports-card__link-icon" />
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="reports-page">
      <div className="reports-page__header">
        <h1 className="reports-page__title">Reports</h1>
        <p className="reports-page__subtitle">Select a report to view and analyze your data</p>
      </div>

      <div className="reports-page__grid">
        {MatchPermission(["Inventory Master Reports"]) && (
          <ReportCard
            title="Inventory Master Reports"
            icon="fa-boxes"
            links={[
              { to: "/report/stock-transfer-report", label: "Stock Transfer Report" },
              { to: "/report/batch-expiry-report", label: "Batch Expiry Report" },
            ]}
          />
        )}
        {MatchPermission(["Purchase Reports", "View Purchase Reports"]) && (
          <ReportCard
            title="Purchase Reports"
            icon="fa-file-invoice-dollar"
            links={[
              { to: "/report/pending-po-report", label: "Pending PO Report" },
              { to: "/report/month-wise-purchase-value", label: "Month Wise Purchase Report" },
              { to: "/report/item-wise-purchase-report", label: "Item-wise Purchase Report" },
              { to: "/report/indent-requirement-report", label: "Indent Requirement Report" },
            ]}
          />
        )}
        {MatchPermission(["Sales Reports"]) && (
          <ReportCard
            title="Sales Reports"
            icon="fa-chart-line"
            links={[
              { to: "/report/customer-wise-sales-report", label: "Customer Wise Sales Report" },
              { to: "/report/item-wise-sales-report", label: "Item Wise Sales Report" },
            ]}
          />
        )}
      </div>
    </div>
  );
}

export default ReportsIndex